import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../context/auth.context';
import { Navigate, useNavigate } from 'react-router-dom';
import Orders from '../components/Orders/Orders';
import { HashLink } from 'react-router-hash-link';
import { useMediaQuery } from 'react-responsive';
import "../css/my-account.css"

import { storage, db } from '../firebase'
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
import { collection, doc, getDoc, updateDoc } from 'firebase/firestore'


function MyAccount() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate()
  const activeHashlink = useMediaQuery({ query: "(max-width: 1024px)" });


  


  const [userInfo, setUserInfo] = useState()
  const [isFetching, setIsFetching] = useState(true);
  const [orders, setOrders] = useState()
  const [activeOrders, setActiveOrders] = useState(false)
  const [editarFoto, setEditarFoto] = useState(false)
  const [isLoadingPicture, setIsLoadingPicture] = useState(false);
  const [pictureURL, setPictureUrl] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  

  useEffect(() => {
    getData()
  }, [])
  console.log("user en myacount", user);
 const getData = async () => {
  try {
    if (!user?.id) return;

    const userRef = doc(db, "users", user.id);
    const userSnap = await getDoc(userRef);

    if (userSnap.exists()) {
      setUserInfo(userSnap.data());
      setOrders(userSnap.data().orders || []);
    }
    setIsFetching(false);
  } catch (error) {
    console.error("Error obteniendo datos de Firestore:", error);
  }
};
  const handleListOrders = () =>  {
    setActiveOrders(!activeOrders)
    setEditarFoto(false)
  }
  const handleEditarFotoPerfil = () => {
    setEditarFoto(!editarFoto)
    setActiveOrders(false)
  } 

  const handlePictureChange = async (e) => {
      setIsLoadingPicture(true)
      const image = e.target.files[0]
      // * upload image to firebaseStorage
      try {
  
        // 1 - Location where the picture is gonna be saved
        const storageRef = ref(storage, `images/${image.name}`) // 1- storage, 2-image-name-URL || 1 {the ref}, 2 {file it-self}
        // 2 - uploading the picture to firebase storage
        const snapShot = await uploadBytes(storageRef, image)
        // 3 - picture Url
        const downloadUrl = await getDownloadURL(snapShot.ref)
        setPictureUrl(downloadUrl)
        setIsLoadingPicture(false)
  
        // 4 - new doc
      } catch (error) {
        navigate("/error");
      }
  
    };
  
   const handleGuardarFotoPerfil = async () => {
  try {
    if (!user?.id) {
      setErrorMessage("No se ha podido identificar al usuario.");
      return;
    }

    const userRef = doc(db, "users", user.id); // referencia al doc en Firestore

    await updateDoc(userRef, {
      picture: pictureURL
    });

    window.alert("FOTO ACTUALIZADA CORRECTAMENTE");
    console.log("aceptado");
    setEditarFoto(false)
    getData();
  } catch (error) {
    console.error("Error actualizando foto:", error);
    setErrorMessage("No se pudo actualizar la foto de perfil.");
  }
};

  if (isFetching === true) {
    return <div class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only"></span>
      </div>
    </div>
  }

  return (
    <div className='user-page'>
      <div className='user-profile'>
        <div className='user-picture'>
          <img src={userInfo?.picture} alt="" />
        </div>
        <div className='user-name'>
          <h2>{userInfo?.email}</h2>
        </div>
      </div>
      {
        orders.length !== 0 &&
        <div>
          <div id={activeHashlink && 'admin-components'}>
            <HashLink smooth to="#admin-components">
              <button onClick={handleEditarFotoPerfil} className="hash-button">Editar Foto de Perfil</button>
              <button onClick={handleListOrders} className="hash-button">Mis Pedidos</button>
            </HashLink>
          </div>
          {activeOrders && <Orders orders={orders} />}
        </div>
      }
     {editarFoto && (
  <>
    <div className="uploader-pic">
      <input onChange={handlePictureChange} type="file" name="picture" />
      <label htmlFor="picture">Product Picture</label>
    </div>
    {isLoadingPicture === true && <p>...loading picture</p>}
    {pictureURL !== "" ? (
      <img
        src={pictureURL}
        alt="yourPic"
        width={200}
        className="uploader-img"
      />
    ) : (
      <p> [ No Picture Selected ]</p>
    )}
    <button
      type="submit"
      onClick={handleGuardarFotoPerfil}
      className="general-btn"
    >
      Guardar
    </button>
    {errorMessage !== "" && (
      <p className="error-message"> * {errorMessage}</p>
    )}
  </>
)}

    </div>
  )
}

export default MyAccount